<template>
	<div class="h-chat">
		<div class="h-header" :style="{'background-color':page.color}">
			<!-- <div class="title">
            <span class="ic-chat" ><img style="width: 24px;" src="https://omnisales.worldfone.vn/portal/assets/images/livechat/icon-white-64x64.png" alt=""></span>
            <h1 class="list-title">{{page.title_ready_text}}</h1>
            <p class="list-desc">{{page.title_agentname_text}}</p>
          </div>
          <div class="head-action">
            <i class="fas fa-cog" v-on:click="toggle_widget_setting"></i>
            <i class="fas fa-times" v-on:click="minimize"></i>
            <ul class="widget-setting-dropdown">
              <li><i class="fas fa-volume-down widget-setting-icon"></i> {{$t('sound')}} <label class="switch"><input type="checkbox" v-model="setting_sound"> <div class="circle round"></div></label></li> 
              <li><i class="fas fa-bell widget-setting-icon"></i> {{$t('notification')}} <label class="switch"><input type="checkbox" v-model="setting_noti"> <div class="circle round"></div></label></li> 
              <li v-on:click="reload_iframe"><i class="fas fa-power-off widget-setting-icon"></i> {{$t('resolve')}}</li>
            </ul>
          </div> -->


			<div class="widget-header--top-wrapper">
				<div class="widget-header-title">
					<!-- {{page.title_ready_text}}  -->{{$t('title_ready_text')}}

				</div>
				<div class="head-action">
					<i class="fas fa-cog" v-on:click="toggle_widget_setting"></i>
					<i class="fas fa-times" v-on:click="minimize"></i>
					<ul class="widget-setting-dropdown">
						<!-- <li><i class="fas fa-volume-down widget-setting-icon"></i> {{$t('sound')}} <label class="switch"><input type="checkbox" v-model="setting_sound"> <div class="circle round"></div></label></li>  -->
						<!-- <li><i class="fas fa-bell widget-setting-icon"></i> {{$t('notification')}} <label class="switch"><input type="checkbox" v-model="setting_noti"> <div class="circle round"></div></label></li> -->
						<!-- <li><i class="fa fa-language widget-setting-icon"></i> {{$t('language')}}
                  <select id="select_lang" v-model="lang" style="float: right; color:#888; margin-right: 11px;" @change="setLang($event)">
                    <option value="vi" >Việt Nam</option>
                    <option value="en" >English</option>
                  </select>               
                </li> -->
						<!-- <li v-on:click="download_msg_txt()"><i class="fas fa-download widget-setting-icon"></i> {{$t('download_message')}}</li> -->

						<li v-on:click="reload_iframe"><i class="fas fa-power-off widget-setting-icon"></i>
							{{$t('resolve')}}</li>
					</ul>
				</div>



			</div>
			<div class="wrap-header-middle" style="display: block">
				<!-- <div class="agent-img" v-if="page.logo">
                <img :src="page.logo" :title="page.title_survey_heading">
              </div> -->

				<div v-if="page.title_agentname_text" class="title">
					<p class="list-desc"><!-- {{page.title_agentname_text}} --> {{$t('title_agentname_text')}}</p>
				</div>
			</div>



		</div>
		<div class="body">
			<div class="chatbox">
				<div class="chat-content-w scroll1">
					<div class="chat-content kkkk">
						<div v-for="(message, index_message) in messages" class="chat-message chat-message-main"
							:class="{self:message.user_id==st_token}">
							<div class="message-sender" v-if="!isHiddenName(index_message)">
								<img v-if="message.user_id!=st_token" class="chat-message-avatar" :alt="message.name"
									:title="message.name" :src="message.profile_pic">
								<p class="user-name" v-if="message.user_id!=st_token">
									{{message.name}}
								</p>
							</div>

							<div class="chat-message-content-w" v-if="message.text !='' || message.url !=''">
								<!-- <div class="chat-message-content" v-if="message.type=='text'">
									<span class="message" v-if="message.text !=''" v-html="detectURL(message.text)"
										:style="[message.user_id!=st_token ? {'background-color':page.color, 'color': '#fff'} : {}]"></span>
								</div> -->
								<template v-if="message.type=='text'">
									<div class="chat-message-content">
										<span class="message" v-if="message.user_id != st_token" v-html="detectURL(message.text)" 
											:style="[message.user_id!=st_token ? {'background-color':page.color, 'color': '#fff'} : {}]"></span>
										<span class="message" v-else 
											:style="[message.user_id!=st_token ? {'background-color':page.color, 'color': '#fff'} : {}]">{{message.text}}</span>
									</div>
								</template>
								<div class="chat-message-content" v-else-if="message.type=='image'">
									<a :href="message.url" >
										<img style="width: 100%;" :src="message.url" :alt="message.text"
											:title="message.text">
									</a>
								</div>
								<div class="chat-message-content"
									v-else-if="message.type=='link' || message.type=='url'">
									<a :href="message.url" target="_blank">{{message.text ? message.text : message.url}}</a>
								</div>
							</div>
							<template v-if="message.attachments">
								<template v-if="message.type == 'rating'">
									<div class="chat-message-content-w">
										<div class="chat-message-content">
											<div class="template_list">
												<div class="slider-container">
													<div class="slider">
														<div class="slides">
															<div class="slide slide--feedback">
																<div class="slide__text">
																	<div class="detail">
																		<div class="title"
																			:style="{'color':page.color}">
																			{{message.attachments.payload.title}}</div>
																		<div class="des">
																			{{message.attachments.payload.subtitle}}
																		</div>
																		<template
																			v-if="message.is_rated && message.rating_star">
																			<div class="title mt-1">{{$t('result')}}:
																				<div class="rating mb-1">
																					<ul class="list">
																						<li v-for="star in message.rating_star"
																							class="star active">
																							<i class="fas fa-star"></i>
																						</li>
																					</ul>
																				</div>
																			</div>
																			<div class="title">{{$t('feedback')}}:
																				{{message.rating_recommend}}</div>
																		</template>
																		<button class="button" type="button" v-else
																			@click.prevent="openFormRating(message)">{{message.attachments.payload.button_title}}</button>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</template>
								<template v-else>
									<div class="chat-message-content-w" v-for="file in message.attachments">
										<div id="greenBar">
											<i class="fa fa-spinner fa-spin" aria-hidden="true"  v-if="index_message==keyAddFile && keyAddFile!=0" ></i>
											<i class="fa fa-check" aria-hidden="true"   v-if="message.send_success==1 "  style="font-size: 1em;opacity: .5;"></i>
										</div>
										<div class="chat-message-content">
											<a :href="file.url" target="_blank" v-if="file.type == 'image'">
												<img style="margin-bottom: 5px;max-width: 320px;" :src="file.url"
													:alt="file.text" :title="file.text">
											</a>
											<div class="video_content" v-else-if="file.type == 'video'" style="width: 320px;padding:10px 5%;border-radius: 10px;">
												<video style="width:100%" height="190"  controls>
													<source :src="file.url" type="video/mp4">
													Your browser does not support the video tag.
												</video>
												<div class="video-icon">
													<img src="https://omnisales.worldfone.vn/portal/assets/images/video.svg" >
													<div class="title">
														<h5>{{file.title}}</h5>
														<div v-if="file.file_size != undefined">
															<span>{{Math.round(file.file_size/(1024*1024)*100)/100}} MB</span>
														</div>
													</div>
												</div>
											</div>
											<div class="template_list" v-else-if="file.type=='template'">
												<template v-if="file.payload.template_type == 'generic'">
													<div class="slider-container">
														<div class="slider">
															<div class="slides" :id="'slides__' + index_message"
																:data-elements="file.payload.elements.length">
																<div v-for="(element, index) in file.payload.elements"
																	:id="'slide__' + index_message + '_' + index"
																	class="slide">
																	<div class="slide__text">
																		<img :src="element.image_url" alt="">
																		<div class="detail">
																			<div class="title"
																				:style="{'color':page.color}">
																				{{element.title}}</div>
																			<div class="des">{{element.subtitle}}</div>

																			<template v-for="button in element.buttons">
																				<a v-if="button.type=='postback'"
																					v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																					class="button">{{button.title}}</a>
																				<a v-if="button.type=='web_url'"
																					:href="button.url" class="button"
																					target="_blank">{{button.title}}</a>

																			</template>

																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div class="wrap-arrow wrap-arrow-prev">
															<div class="inner-arrow">
																<a class="slide__prev"
																	:id="'slide__prev_' + index_message"
																	@click.prevent="changePrev(index_message)"
																	:href="'#slide__' + index_message + '_' + (file.payload.elements.length - 1)"
																	title="Prev"></a>
																<!-- <a class="slide__prev" :id="'slide__prev_' + index_message" :href="'#slide__' + index_message + '_' + (file.payload.elements.length - 1)" title="Prev"></a> -->
															</div>
														</div>
														<div class="wrap-arrow wrap-arrow-next">
															<div class="inner-arrow">
																<a class="slide__next"
																	:id="'slide__next_' + index_message"
																	@click.prevent="changeNext(index_message)"
																	:href="'#slide__' + index_message + '_1'"
																	title="Next"></a>
																<!-- <a class="slide__next" :id="'slide__next_' + index_message" :href="'#slide__' + index_message + '_1'" title="Next"></a> -->
															</div>
														</div>
													</div>
												</template>
												<template v-else-if="file.payload.template_type == 'media'">
													<div class="slider-container">
														<div class="slider">
															<div class="slides" :id="'slides__' + index_message"
																:data-elements="file.payload.elements.length">
																<div v-for="(element, index) in file.payload.elements"
																	:id="'slide__' + index_message + '_' + index"
																	class="slide">
																	<div class="slide__text">
																		<img :src="element.url" alt=""
																			v-if="element.media_type == 'image'">
																		<video width="320" height="240"
																			v-else-if="element.media_type == 'video'"
																			controls>
																			<source :src="element.url" type="video/mp4">
																			Your browser does not support the video tag.
																		</video>
																		<div class="detail">
																			<!-- <div class="title" :style="{'color':page.color}">{{element.title}}</div>
												<div class="des">{{element.subtitle}}</div> -->
																			<template v-for="button in element.buttons">
																				<a v-if="button.type=='postback'"
																					v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																					class="button">{{button.title}}</a>
																				<a v-if="button.type=='web_url'"
																					:href="button.url" class="button"
																					target="_blank">{{button.title}}</a>
																			</template>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</template>
												<template v-else-if="file.payload.template_type == 'ticket'">
													<div class="slider-container" v-if="file.payload.template_data">
														<div class="slider slider--ticket">
															<div class="slides" :id="'slides__' + key_message">
																<div class="slide">
																	<div class="slide__text slide__text--ticket">
																		<h3 class="slide__text--ticket__title">
																			{{file.payload.template_data.title}}</h3>
																		<h6 class="slide__text--ticket__subtitle">
																			{{file.payload.template_data.subtitle}}</h6>
																		<template
																			v-if="file.payload.template_data.params">
																			<ul class="table-content-list pl-0">
																				<li
																					v-for="param in file.payload.template_data.params">
																					<div class="item">
																						<span>{{param.title}}</span>
																						<span
																							class="">{{param.value}}</span>
																					</div>
																				</li>
																			</ul>
																		</template>
																		<div class="detail detail--ticket text-center">
																			<template
																				v-for="button in file.payload.template_data.buttons">
																				<a v-if="button.type=='postback'"
																					v-on:click="send_postback(message.id, button.payload, button.title, 'generic')"
																					class="button">{{button.title}}</a>
																				<a v-if="button.type=='web_url'"
																					:href="button.url" class="button"
																					target="_blank">{{button.title}}</a>
																			</template>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</template>
												<div v-else>
													<ul class="list_ul">
														<li v-for="(element, index) in file.payload.elements">
															<div v-if="element.default_action && element.default_action.type=='web_url'"
																class="clearfix">
																<a :href="element.default_action.url"
																	:title="element.title" target="_blank">
																	<img :src="element.image_url" />
																	<h3>{{element.title}}</h3>
																	<p v-if="element.description">
																		{{element.description}}
																	</p>
																</a>
															</div>
															<div v-else-if="element.default_action && element.default_action.type=='postback'"
																v-on:click="send_postback(message.id, element.default_action.payload, element.title, 'attachment_list')"
																class="clearfix">
																<img :src="element.image_url" />
																<h3>{{element.title}}</h3>
																<p v-if="element.description">{{element.description}}
																</p>
															</div>
															<div v-else class="clearfix">
																<img :src="element.image_url" />
																<h3>{{element.title}}</h3>
																<p v-if="element.description">{{element.description}}
																</p>
															</div>
														</li>
													</ul>
												</div>
											</div>
											
											<a class="file_pdf" :href="file.url" target="_blank" v-if="file.type == 'file' && (getExtension(file.title)=='pdf' || getExtension(file.title)=='docx' || getExtension(file.title)=='xlsx'|| getExtension(file.title)=='xls'|| getExtension(file.title)=='doc'|| getExtension(file.title)=='rar'|| getExtension(file.title)=='zip'|| getExtension(file.title)=='ppt'|| getExtension(file.title)=='pptx')" style="width: 320px;padding:10px 5%;border-radius: 10px;">
												<div class="video-icon">
													<img :src="'/assets/images/'+getExtension(file.title)+'_icon.svg'" >
													<div class="title">
														<h5>{{file.title}}</h5>
														<div v-if="file.file_size != undefined">
															<span>{{Math.round(file.file_size/(1024*1024) *100)/100}} MB</span>
														</div>
													</div>
												</div>
												
												<!-- {{file.title}} -->
											</a>
											<a :href="file.url" class="file_pdf" target="_blank" v-else-if="file.type == 'file' && (getExtension(file.title)!='pdf' && getExtension(file.title)!='docx' && getExtension(file.title)!='xlsx')" style="width: 320px;padding:10px 5%;border-radius: 10px;">
												<div class="video-icon">
												  <div class="img" style="background-image: url('/assets/images/icon.svg');width: 42px;height:52px;background-size:100% 100%" ><span>{{getExtension(file.title)}}</span></div>
												  <!-- <img src="/assets/images/icon.svg" > -->
												  <div class="title">
													<h5>{{file.title}}</h5>
													<div v-if="file.file_size != undefined">
													  <span>{{Math.round(file.file_size/(1024*1024) *100)/100}} MB</span>
													</div>
												  </div>
												</div>
											</a>
											<!-- <a :href="file.url" target="_blank" v-else>{{message.text ? message.text : message.url}}</a> -->
										</div>
									</div>
								</template>
							</template>

							<div v-if="message.quick_replies && message.quick_replies.status==1 && index_message == Object.keys(messages).length - 1"
								class="quick-replies">
								<template v-for="(reply, index) in message.quick_replies.data">
									<div class="reply" v-if="reply.content_type=='text'"
										:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
										v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')"
										:style="{'border-color':page.color}">
										<a>{{reply.title}}</a>
									</div>
									<div class="reply" v-if="reply.content_type=='postback'"
										:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
										v-on:click="send_postback(message.id, reply.payload, reply.title, 'reply')"
										:style="{'border-color':page.color}">
										<a>{{reply.title}}</a>
									</div>
									<div class="reply" :id="'location_'+message.id"
										v-if="reply.content_type=='location'"
										:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
										v-on:click="send_postback(message.id, reply.payload, reply.title, 'location')"
										:style="{'border-color':page.color}">
										<a>{{reply.title}}</a>
									</div>
									<div class="reply" v-if="reply.content_type=='web_url'"
										:class="(page.important_button && page.important_button.includes(reply.title)) ? 'active' :''"
										:style="{'border-color':page.color}">
										<a :href="reply.payload" target="_blank">{{reply.title}}</a>
									</div>
								</template>
							</div>

							<div :data-time="message.date_added" class="chat-message-date"
								v-show="!isHiddenTime(index_message)">{{message.date}}</div>
						</div>
						<div v-if="show_typing" class="chat-message">
							<div class="chat-message-content-w">
								<div class="chat-message-content">
									<span class="message" :style="{'background-color':page.color, 'color': '#fff'}">
										<div class="loading-dots">
											<div class="loading-dots--dot"></div>
											<div class="loading-dots--dot"></div>
											<div class="loading-dots--dot"></div>
										</div>
									</span>
								</div>
							</div>
						</div>

						<app-rating-vietjet v-if="show_rating && page.parent_user =='C1184'"
							:config="customerFeedbackConfig"></app-rating-vietjet>
						<app-rating v-else-if="show_rating" :config="customerFeedbackConfig"
							@close-feedback-form="closeFormRating"></app-rating>
						<!-- <app-notification v-if="!isMobile() && setting_noti === '' "></app-notification> -->
					</div>
					<section v-if="show_suggest" aria-label="predictive suggestions"
						class="suggestions PredictiveSuggestions__list__container PredictiveSuggestions__list__container--desktop PredictiveSuggestions--collapsed"
						id="predictive-suggestions-container">
						<div class="PredictiveSuggestions__list__title PredictiveSuggestions__list__title--animate-in">
							<button type="button" class="PredictiveSuggestions__suggestions-heading"
								id="predictive-suggestions-heading" tabindex="0">
								Đề xuất
							</button>
						</div>
						<div class="PredictiveSuggestions__list__items PredictiveSuggestions__list__items--animate-in">
							<ul class="PredictiveSuggestions__list PredictiveSuggestions--animating-list-up PredictiveSuggestions__list--desktop"
								id="predictive-suggestions-list">
								<li v-for="suggest in suggest_data"
									class="PredictiveSuggestions__list__listItem--desktop" accesskey="f"><button
										v-on:click="clickMenu(suggest.value, suggest.title)"
										class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker"
										tabindex="0" type="button"
										style="color: rgb(240, 14, 14); animation-play-state: paused;"><span
											style="color: rgb(240, 14, 14);">{{suggest.title}}</span></button></li>

								<!-- <li class="PredictiveSuggestions__list__listItem--desktop" accesskey="g"><button class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker" tabindex="0" type="button" style="color: rgb(240, 14, 14); animation-play-state: paused;"><span style="color: rgb(240, 14, 14);">Bảo hiểm du lịch cho Covid-19 (Tune Protect)</span></button></li>
                        <li class="PredictiveSuggestions__list__listItem--desktop" accesskey="h"><button class="PredictiveSuggestions__item PredictiveSuggestions__item--starting-height-with-text PredictiveSuggestions__item--animate-flicker" tabindex="0" type="button" style="color: rgb(240, 14, 14); animation-play-state: paused;"><span style="color: rgb(240, 14, 14);">Bay an toàn với VietJet Air</span></button></li> -->
							</ul>
						</div>
					</section>
				</div>
				<div id="modalStatus" class="modal-wrapper">
					<div class="modal">
						<a href="#close" title="Close" class="close" @click="closeModal()">X</a>
						<div class="modal-header">
							<h2>{{error.title}}</h2>
						</div>
						<div class="modal-content">
							<p>{{error.description}}</p>
						</div>
					</div>
				</div>
				<div id="modal-phonenumber" class="modal-wrapper">
					<div class="modal">
						<a href="#close" title="Close" class="close" @click="closePhoneModal()">X</a>
						<div class="modal-header">
							<h4>{{phoneNumber}}</h4>
						</div>
						<div class="modal-content">
							<div style="width: 100%; margin-bottom: 10px;">
								<a href="#" @click.prevent="copyPhoneNumber()" style="color: initial"><strong>Sao chép</strong></a>
							</div>
							<div style="width: 100%;">
								<a :href="'tel:' + phoneNumber" style="color: initial"><strong>Gọi điện</strong></a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="chat-controls">
				<div v-if="show_menu" class="mini-menu">
					<ul>
						<li v-for="menu_item in page.listmenu">
							<a v-if="menu_item.type=='postback'"
								v-on:click="clickMenu(menu_item.value, $t(menu_item.name)/*menu_item.name*/)">{{$t(menu_item.name)}}</a>
							<a v-else-if="menu_item.type=='website'" v-on:click="show_menu = false"
								:href="menu_item.value" target="_blank">{{$t(menu_item.name)}}</a>
							<a v-else-if="menu_item.type=='phone'" v-on:click="show_menu = false"
								:href="'tel:'+menu_item.value">{{$t(menu_item.name)}}</a>
						</li>
						<!-- <li>Gọi điện</li> -->
						<!-- <li>Hướng dẫn chung</li> -->
					</ul>
				</div>
				<div v-if="messageInputLength > 1024" style="font-size: .7em; color: #c00;text-align: center;">( Bạn
					không được nhập quá 1024 ký tự )</div>
				<div class="chat-input flex_container" style="display: flex; width: 100%; color: #808080;">
					<!-- <div class="flex_item_left"> 
                    <i v-if="page.listmenu" @click="show_menu = !show_menu" class="fas fa-bars" style="cursor: pointer;"></i>
                    <i @click="upload_file" class="fas fa-paperclip" style="margin: 0px 10px 0 3px;cursor: pointer;"></i>
                    <input style="display: none; visibility: hidden;" ref="fileImage" type="file" accept="file_extension|audio/*|video/*|image/*|media_type" @change="onFileSelected" name="" value="" placeholder="">
                  </div>  -->
					<textarea class="flex_item_right " ref="input_chat" style="height: 28px; flex: 1;"
						v-model="message_input" @keydown.enter.exact.stop.prevent="enter_chat()"
						v-on:keyup="handleKeyUp" @input="mixin_autoResize_resize"
						:placeholder="$t('title_ready_enter_text')"></textarea>
					<div class="flex_item icon-sendfile">
						<i v-if="page.listmenu" @click="show_menu = !show_menu" class="fas fa-bars"
							style="cursor: pointer;"></i>
						<i @click="upload_file" class="fas fa-paperclip" style="padding: 8px;cursor: pointer;"></i>
						<input id="FileSelectedValue" style="display: none; visibility: hidden;" ref="fileImage" type="file" 
							accept="file_extension|audio/*|video/*|application/pdf|image/*|media_type" @change="onFileSelected" name=""
							value="" placeholder="">
					</div>
					<div class="flex_item sendchat_box">
						<div class="sendchat_button" @click.prevent="enter_chat()">{{$t('send')}}</div>
					</div>
				</div>
				<!-- <div class="chat-action">
                <a class="btn-upload" @click="upload_file"><i class="fas fa-paperclip"></i></a>
                <div>
                  <input style="display: none; visibility: hidden;" ref="fileImage" type="file" accept="file_extension|audio/*|video/*|image/*|media_type" @change="onFileSelected" name="" value="" placeholder="">
                </div>
              </div> -->

				<!-- </div> -->
			</div>
		</div><!--body-->

		<div class="footer-note" v-if="page.privacy_link">
			<a class="product" target="_blank" :href="page.privacy_link">Quyền riêng tư</a>
		</div>
		<div class="footer-note" v-else>
			<label class="lang-option"
				v-if="typeof page.languages !== 'undefined' && Object.keys(page.languages).length>0">
				<i :style="{'color': page.color}" class="fas fa-globe"></i> {{$t('language')}}
				<select v-model="lang" @change="setLang($event)">
					<option value="vi">Tiếng Việt</option>
					<option value="en">English</option>
				</select>
			</label>
			<div v-if="page.hide_power_by!= 1">
				<span>⚡ by </span><a class="product" target="_blank"
					href="https://worldfone.vn/dich-vu/tong-dai-contact-center-worldfone4x"> Worldfone4Omni</a>
			</div>
		</div>
	</div>

</template>

<script>
	//# sourceURL=pen.js

	// import io from 'socket.io-client';
	import Rating from '../components/rating.vue';
	import rating_vietjet from '../components/rating_vietjet.vue';
	import notification1 from '../components/notification.vue';
	import sound from '../assets/media/notif.mp3';
	import axios from 'axios';
	export default {
		components: {
			'app-rating': Rating,
			'app-rating-vietjet': rating_vietjet,
			'app-notification': notification1
		},
		props: ['page'/*, 'show_launcher', 'first_component'*/],
		data() {
			return {
				setting_sound: window.livechat.setting_sound,
				setting_noti: window.livechat.setting_noti,
				// setting_language: window.livechat.setting_language,
				new_message_number: 0,
				message_input: '',
				messages: [],
				agent_id: '',
				agent: {
					name: '',
					avatar: '',
				},
				user_has_created: false,
				selectedFile: null,
				current_time_m: ENV.current_time,
				current_time_n: ENV.current_time,
				timer: '',
				timeoutVal: 1000, // time it takes to wait for user to stop typing in ms,
				timer_show_typing: '',
				lang1: '',
				show_suggest: 0,
				suggest_data: [],
				show_typing: 0,
				show_menu: 0,
				/*menus:[
				{type: 'postback', name: 'Danh mục chính', value: '#daddasadasdas'},
				{type: 'website', name: 'Hướng dẫn chung', value: 'https://omnicxm.worldfone.cloud/omni/botai/view/detail/61c932994a67137a262ab3f2'},
				{type: 'phone', name: 'Gọi hỗ trợ', value: '0366446318'}
				]*/
				// show_notification: 'true',
				slideIndexes: {},
				customerFeedbackConfig: null,
				error: {
					title: '',
					description: '',
				},
				phoneNumber: '',
				keyAddFile:0,
				msg_idAddFile:'',
				keyAddFileSuccess:'',
				// typeFileAdd:'',
				// nameFileAdd:'',
			}
		},

		computed: {
			st_token() {
				return this.$store.state.st_token;
			},
			lang() {
				return this.$store.state.lang;
			},
			show_rating() {
				return this.$store.state.show_rating;
			},
			page() {
				return this.$store.state.page;
			},
			hasFocus() {
				return this.$store.state.hasFocus;
			},
			show_launcher() {
				if (this.$store.state.show_launcher == 1 && this.page.parent_user== 'P0008_prod' && this.messages<=0) {
					this.message_input = 'Bắt đầu';
					this.enter_chat();

				}
				return this.$store.state.show_launcher;
			},
			first_component() {
				return this.$store.state.first_component;
			},
			messageInputLength() {
				return this.message_input.length;
			},
		},

		methods: {
			poll: function () {
				var self1 = this;
				var ajax = new XMLHttpRequest();
				ajax.onreadystatechange = function () {
					if (this.readyState === 4 && this.status === 200) {
						if (this.status === 200) {
							try {
								var json = JSON.parse(this.responseText);
								if (json.status == 1) {
									self1.current_time_m = json['ts'];
									
									self1.add_messages(json['data']);
									self1.poll();

								} else {
									console.log(json.error);
									setTimeout(() => {
										self1.poll();
									}, 3000);
								}
							} catch {
								self1.current_time_m = self1.current_time_m + 3;
								self1.poll();
								return;
							}
						} else {
							setTimeout(() => {
								self1.poll();
							}, 3000);
						}

					} else if (this.status > 299 && this.readyState == 4) {
						setTimeout(() => {
							self1.poll();
						}, 3000);
						console.log('Server Error: ' + ajax.statusText);
					} else {
					}
				}
				ajax.onerror = function () {
					console.log('xmlHTTP Error', ajax.responseText);
					setTimeout(() => {
						self1.poll();
					}, 3000);
				}
				
				ajax.open('GET', '/app/v1/public/pull/message/' + self1.st_token + '/' + self1.current_time_m, true);
				ajax.send();
				
			},
			polln: function () {
				var self1 = this;
				var ajax = new XMLHttpRequest();
				ajax.onreadystatechange = function () {
					if (this.readyState === 4 && this.status === 200) {
						if (this.status === 200) {
							try {
								var json = JSON.parse(this.responseText);
								if (json.status == 1) {
									self1.current_time_n = json['ts'];
									json['data'].forEach(function (message, index) {
										if (message.trigger == 'rating') {
											self1.$store.commit('show_rating', true);
										} else if (message.trigger == 'suggest') {
											self1.show_suggest = true;
											self1.suggest_data = message.suggest;
											setTimeout(function () {
												self1.scrollToEnd();
											}, 250);
											// self1.$store.commit('show_suggest', true);
										} else if (message.trigger == 'change_language') {
											self1.setLangNotificationEvent(message.language);
										}
									});

									self1.polln();

								} else {
									console.log(json.error);
									setTimeout(() => {
										self1.polln();
									}, 3000);
								}
							} catch {
								self1.current_time_n = self1.current_time_n + 3;
								self1.polln();
								return;
							}
						} else {
							setTimeout(() => {
								self1.polln();
							}, 3000);
						}

					} else if (this.status > 299 && this.readyState == 4) {
						setTimeout(() => {
							self1.poll();
						}, 3000);
						console.log('Server Error: ' + ajax.statusText);
					} else {
					}
				}
				ajax.onerror = function () {
					console.log('xmlHTTP Error', ajax.responseText)
					setTimeout(() => {
						self1.polln();
					}, 3000);
				}
				ajax.open('GET', '/app/v1/public/pull/notifications/' + self1.st_token + '/' + self1.current_time_n, true);
				ajax.send();
			},
			mixin_autoResize_resize(event) {
				if (event.target.value == '') {
					event.target.style.height = '28px';
				} else {
					event.target.style.height = "auto";
					event.target.style.height = `${event.target.scrollHeight}px`;
				}

			},
			get_messages() {
        var $self = this;
        axios.get('/app/v1/public/v2/get_messages', {
					params: {
						st_token: $self.st_token,
						livechat_id: livechat.getId(),
					}
				}).then((response) => {
					if (response.data.status == 1) {
						var data = response.data.data;
						$self.messages = data;
						$self.current_time_m = response.data.last_mes_time;
						// $self.current_time_n = response.data.last_mes_time;
						$self.poll();
						$self.polln();

						setTimeout(function () {
							$self.insertDateLine();
						}, 150);
						$self.scrollToEnd();
					} else {
						//if ($self.page.onoff_surver == 1) {//thì add code, không thì cho chat với token mới, nhớ check để tạo user, khi user chat tin nhắn đầu tiên
							$self.$store.commit('set_first_component', 'survey');
						//}
						
						// $self.poll();
						// $self.polln();
					}


				}).catch(error => {
					console.log(error);
				});
      },
			add_messages: function (data) {
				var $self = this;
				$self.$store.commit('show_rating', false);
				data.forEach(function (message1, index) {
					var msg_id = message1.msg_id;
					if (typeof msg_id !== 'undefined') {
						var index = $self.messages.findIndex(message => message.msg_id === msg_id);
						if (parseInt(index) >= 0) {
							//update đã nhận
							if($self.msg_idAddFile==msg_id){
								$self.keyAddFile=0;
								var msgTemp = message1;
								// $self.$set(msgTemp, 'send_success', 1);
								message1.send_success = 1;
							}
							$self.messages.splice(index,1,message1);
						} else {
							$self.messages.push(message1);
						}
					} else {
						$self.messages.push(message1);
					}

					// $self.messages.push(message1);
					$self.new_message_number++;
					$self.$emit('new_message_number', $self.new_message_number);

					// if (message1.user_id!= $self.st_token && $self.setting_sound==true) {        
					//   // $self.playSound(sound);
					// }
					if(message1.user_id != $self.st_token){
						$self.set_show_typing(0);
					}
					if (message1.user_id != $self.st_token && $self.setting_noti == true) {
						$self.showNotification(message1.name, message1.text, message1.profile_pic);
					}
				});
				setTimeout(function () {
					$self.scrollToEnd();
				}, 250);


			},
			getExtension(filename) {
				if(filename != undefined && filename.length >0){
					var parts = filename.split('.');
					return parts[parts.length - 1];
				}else{
					return '';
				}
			},
			
			async onFileSelected(event) {
				var $self = this;
				$self.selectedFile = event.target.files[0];
				// console.log($self.selectedFile.name)
				let typeFile=$self.getExtension($self.selectedFile.name);
				// let exclusionType=['exe','bat','msi','bin'] ;
				let exclusionType=['xlsx','xls','pdf','txt','doc','docx','ppt','pptx','zip','rar'] ;
				let videoType=['mp4','mpeg','x-ms-wmv','quicktime'];
				let imageType=['jpeg','png','jpeg','jpg'];
        		let type='';
				let extension= typeFile;
				var d = new Date();
				if(videoType.includes(typeFile)) {
					typeFile='video';
          		type='video';
				}
				if(imageType.includes(typeFile)) {
					typeFile='image';
					 type='image';
				}
       
        		if(!exclusionType.includes(typeFile) && type.length == 0) {
					$self.error.title = 'Lỗi';
					$self.error.description = 'File của bạn gửi không hợp lệ.';
					$('#modalStatus').css('opacity', 1);
					$('#modalStatus').css('zIndex', 999999999)
					return false;
				}else{
          			 type='file';
        		}
				if ($self.selectedFile.size <= 1024 * 1024 * 25) {
					$self.msg_idAddFile='';
					let files = $('#FileSelectedValue')[0].files;
					let newObjectUrl = URL.createObjectURL(files[0]);
					// console.log(newObjectUrl)
					const formdata = new FormData();
					
					formdata.append('file', $self.selectedFile, $self.selectedFile.name);
					$self.keyAddFile=$self.messages.length ;
					var msg_id = $self.uid();
					$self.msg_idAddFile=msg_id;
					let attachments=[];
					let attachments_data={
							'extension':extension,
							'file_size':$self.selectedFile.size,
							'mimetype':$self.selectedFile.type,
							'raw_file_name': $self.selectedFile.name,
							'type':type,
							'title': $self.selectedFile.name,
							'url':newObjectUrl
						};
					attachments.push(attachments_data);
					$self.messages.push({
						id: "",
						attachments:attachments,
						msg_id: msg_id,
						type: "text",
						is_rated:0,
						profile_pic :  "",
						rating_recommend: "",
						rating_star: 0,
						text: '',
						url:'',
						name:window.user.name,
						user_id: $self.st_token,
						date_added: Math.floor(Date.now() / 1000),
						date: d.getHours() + ":" + d.getMinutes()
					});
					$self.scrollToEnd();
					// console.log($self.messages)
					// .file_pdf_progress.progress 
					// formdata.append('a', {page_id: livechat.getId()})
					// formdata.append('data', {
					//   page_id: livechat.getId(),
					//   text: $self.selectedFile.name,
					//   sender_id: $self.st_token,
					//   name: window.user.name,
					//   survey_data: {
					//     name:window.user.name,
					//     phone:window.user.phone,
					//     email:window.user.email,
					//     address:window.user.address
					//   }, 
					//   properties:window.user.properties
					// }/*this.selectedFile,this.selectedFile.name*/);
					await axios.post('/app/v1/public/upload/image', formdata, {
						params: {
							page_id: livechat.getId(),
							msg_id: msg_id,
							text: $self.selectedFile.name,
							sender_id: $self.st_token,
							name: window.user.name,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							properties: window.user.properties
						},
						headers: {
							"Content-Type": "multipart/form-data",
						},
					})
					.then(function (response) {
						/*socket.emit('SEND_IMG' ,{
							page_id: livechat.getId(),
							text: $self.selectedFile.name,
							url: response.data.content,
							sender_id: $self.st_token,
							name: window.user.name,
							survey_data: {
							name:window.user.name,
							phone:window.user.phone,
							email:window.user.email,
							address:window.user.address
							}, 
							properties:window.user.properties
						});*/
						$("#FileSelectedValue").val('');
						if (response.data.status==0) {
							$self.messages.splice($self.keyAddFile,1);
							$self.keyAddFile=0;
							$self.msg_idAddFile='';
							$self.error.title = 'Error!';
							$self.error.description =response.data.error;
							$('#modalStatus').css('opacity', 1);
							$('#modalStatus').css('zIndex', 999999999)
						}
						else{
							$self.keyAddFileSuccess=$self.keyAddFile;
							$self.keyAddFile=0;
						}
					})
					.catch(function (error) {
						console.log(error.data);
						// console.log(error);
					})
				}
				else {
					$self.error.title = 'Lỗi';
					$self.error.description = 'Dung lượng file không được quá 25MB';
					$('#modalStatus').css('opacity', 1);
					$('#modalStatus').css('zIndex', 999999999)
				}
			},
			upload_file: function ($event) {
				var $self = this;
				var elem = this.$refs.fileImage
				elem.click()
				const formdata = new FormData();
				formdata.append('file', this.selectedFile);
			},
			generate_uuid4: function (e) {
				var dt = new Date().getTime();
				var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
					var r = (dt + Math.random() * 16) % 16 | 0;
					dt = Math.floor(dt / 16);
					return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
				});
				return uuid;
			},
			enter_chat(e) {
				var $self = this;
				if (!$self.st_token) {
					$self.$store.commit('set_token', $self.generate_uuid4());
					livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', $self.st_token);
					$self.poll();
					$self.polln();
				}

				// console.log($self.st_token);return;
				if ($self.messageInputLength < 1024) {
					this.show_suggest = false;
					this.$refs.input_chat.style.height = '28px';
					var text = this.message_input.trim();
					var msg_id = $self.uid();
					var d = new Date();
					window.clearTimeout(this.timer);
					//gởi tin nhắn
					var text_trim = text.trim();
					if (text_trim == '' || text_trim === null) {
						$self.message_input = '';
						return false;
					} else {
						$self.messages.push({
							id: "",
							msg_id: msg_id,
							trigger: "message",
							source: "livechat",
							type: "text",
							text: $self.escapeHtml(text),
							user_id: $self.st_token,
							date_added: Math.floor(Date.now() / 1000),
							date: d.getHours() + ":" + d.getMinutes()
						});


						axios.post('/app/v1/public/SEND_MESSAGE', {
							page_id: livechat.getId(),
							msg_id: msg_id,
							text: text,
							sender_id: $self.st_token,
							name: window.user.name,
							windowInfo: livechat.windowInfo,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							properties: window.user.properties
						}).then((response) => {
							if (response.data.status == 1) {
							}
							if(response.data.show_typing){
								if ($self.page.parent_user == 'C1184') {
									window.setTimeout(() => {
										$self.set_show_typing(1, 3);
									}, 800);
								}
								else{
									window.setTimeout(() => {
										$self.set_show_typing(1, 5);
									}, 300);
								}
							}
						}).catch(error => {
							console.log(error);
						});


						$self.message_input = '';
						// console.log($self.message_input);


						$self.scrollToEnd();
						// e.preventDefault();
						return false;
					}
				}

			},
			handleKeyUp(e) {
				if (e.keyCode === 13) {
				} else {
					window.clearTimeout(this.timer); // prevent errant multiple timeouts from being generated
					this.timer = window.setTimeout(() => {
						var $self = this;
						axios.post('/app/v1/public/TYPING', {
							page_id: livechat.getId(),
							text: $self.message_input,
							sender_id: $self.st_token,
							name: window.user.name,
							windowInfo: livechat.windowInfo,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							properties: window.user.properties
						}).then((response) => {
						}).catch(error => {
							console.log(error);
						});
					}, this.timeoutVal);
				}
			},
			set_show_typing(show_typing, seconds = 3) {
				var $self = this;
				$self.show_typing = show_typing;
				window.clearTimeout(this.timer_show_typing); // prevent errant multiple timeouts from being generated

				if (show_typing) {
					var lastmessforagent = $self.messages[$self.messages.length - 2];

					// if (typeof lastmessforagent.name !== 'undefined' && $self.page.page_info.name != lastmessforagent.name) { //neu ko phải do page nhắn mà do user nào dc assign
					// 	return false;
					// }

					this.timer_show_typing = window.setTimeout(() => {
						var $self = this;
						$self.set_show_typing(0);
					}, seconds * 1000);


				}

			},
			getLocation(message_id) {
				var $self = this;
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(function (position) {
						// Retrieve the latitude and longitude
						var latitude = position.coords.latitude;
						var longitude = position.coords.longitude;

						// Do something with the coordinates, e.g., display them on the webpage
						return { latitude: latitude, longitude: longitude }
					}, function (error) {
						// Handle any errors that occur during geolocation
						switch (error.code) {
							case error.PERMISSION_DENIED:
								console.error("User denied the request for geolocation.");
								break;
							case error.POSITION_UNAVAILABLE:
								console.error("Location information is unavailable.");
								break;
							case error.TIMEOUT:
								console.error("The request to get user location timed out.");
								break;
							case error.UNKNOWN_ERROR:
								console.error("An unknown error occurred.");
								break;
						}
					});

				} else {
					return "Geolocation is not supported by this browser.";
				}
			},
			// showPosition(position) {

			// 	return {latitude: position.coords.latitude,longitude:position.coords.longitude}
			// },
			send_postback(message_id, payload, title, type) {
				var $self = this;
				var msg_id = $self.uid();
				var d = new Date();

				$self.messages.push({
					id: "",
					msg_id: msg_id,
					trigger: "message",
					source: "livechat",
					type: "text",
					text: title,
					user_id: $self.st_token,
					date_added: Math.floor(Date.now() / 1000),
					date: d.getHours() + ":" + d.getMinutes()
				});
				let location = [];
				if (type == 'location') {
					if (navigator.geolocation) {
						navigator.geolocation.getCurrentPosition(function (position) {
							// Retrieve the latitude and longitude
							var latitude = position.coords.latitude;
							var longitude = position.coords.longitude;

							// Do something with the coordinates, e.g., display them on the webpage
							location = { latitude: latitude, longitude: longitude };
							axios.post('/app/v1/public/SEND_POSTBACK', {
								page_id: livechat.getId(),
								msg_id: msg_id,
								sender_id: $self.st_token,
								name: window.user.name,
								windowInfo: livechat.windowInfo,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								postback: {
									message_id: message_id,
									// index: index,
									payload: payload,
									title: title,
									type: type,
									location: location
								},

								properties: window.user.properties
							}).then((response) => {
								if (response.data.show_typing) {
									window.setTimeout(() => {
										$self.set_show_typing(1, 5);
									}, 300);

								}
							}).catch(error => {
								console.log(error);
							});
						}, function (error) {
							// Handle any errors that occur during geolocation
							switch (error.code) {
								case error.PERMISSION_DENIED:
									location = { 'error': 1, 'message': 'User denied the request for geolocation.' }
									break;
								case error.POSITION_UNAVAILABLE:
									location = { 'error': 1, 'message': 'Location information is unavailable.' }
									break;
								case error.TIMEOUT:
									location = { 'error': 1, 'message': 'The request to get user location timed out.' }
									break;
								case error.UNKNOWN_ERROR:
									location = { 'error': 1, 'message': 'An unknown error occurred.' }
									break;
							}
							axios.post('/app/v1/public/SEND_POSTBACK', {
								page_id: livechat.getId(),
								msg_id: msg_id,
								sender_id: $self.st_token,
								name: window.user.name,
								windowInfo: livechat.windowInfo,
								survey_data: {
									name: window.user.name,
									phone: window.user.phone,
									email: window.user.email,
									address: window.user.address
								},
								postback: {
									message_id: message_id,
									// index: index,
									payload: payload,
									title: title,
									type: type,
									location: location
								},

								properties: window.user.properties
							}).then((response) => {
								if (response.data.show_typing) {
									window.setTimeout(() => {
										$self.set_show_typing(1, 5);
									}, 300);

								}
							}).catch(error => {
								console.log(error);
							});
						});

					} else {
						location = { 'error': 1, 'message': 'Geolocation is not supported by this browser.' }
						axios.post('/app/v1/public/SEND_POSTBACK', {
							page_id: livechat.getId(),
							msg_id: msg_id,
							sender_id: $self.st_token,
							name: window.user.name,
							windowInfo: livechat.windowInfo,
							survey_data: {
								name: window.user.name,
								phone: window.user.phone,
								email: window.user.email,
								address: window.user.address
							},
							postback: {
								message_id: message_id,
								// index: index,
								payload: payload,
								title: title,
								type: type,
								location: location
							},

							properties: window.user.properties
						}).then((response) => {
							if (response.data.show_typing) {
								window.setTimeout(() => {
									$self.set_show_typing(1, 5);
								}, 300);

							}
						}).catch(error => {
							console.log(error);
						});
					}



				} else {
					axios.post('/app/v1/public/SEND_POSTBACK', {
						page_id: livechat.getId(),
						msg_id: msg_id,
						sender_id: $self.st_token,
						name: window.user.name,
						windowInfo: livechat.windowInfo,
						survey_data: {
							name: window.user.name,
							phone: window.user.phone,
							email: window.user.email,
							address: window.user.address
						},
						postback: {
							message_id: message_id,
							// index: index,
							payload: payload,
							title: title,
							type: type,
						},

						properties: window.user.properties
					}).then((response) => {
						if (response.data.show_typing) {
							window.setTimeout(() => {
								$self.set_show_typing(1, 5);
							}, 300);
						}
					}).catch(error => {
						console.log(error);
					});
				}

			},
			clickMenu(payload, title) {
				var $self = this;
				$self.show_menu = false;
				$self.show_suggest = false;
				axios.post('/app/v1/public/SEND_POSTBACK', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					postback: {
						payload: payload,
						title: title,
					},
					// properties:window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {

					}
				}).catch(error => {
					console.log(error);
				});
			},
			minimize: function () {
				$('.h-btn').removeClass('zoomOut');
				$('.hotline-launcher').hide();
				this.new_message_number = 0;
				this.$emit('new_message_number', 0);
				top.postMessage({ st_popup_status: 0 }, document.referrer);
				// this.show_launcher = 0;
				this.$store.commit('set_show_launcher', 0);
			},
			reload_iframe: function () {
				var $self = this;
				/*socket.emit('LEAVE_CONVERSATION' ,{
				  page_id: livechat.getId(),
				  sender_id: $self.st_token,
				  name: window.user.name,
				  windowInfo:livechat.windowInfo,
				  survey_data: {
					name:window.user.name,
					phone:window.user.phone,
					email:window.user.email,
					address:window.user.address
				  }, 
				  properties:window.user.properties
				});*/

				axios.post('/app/v1/public/LEAVE_CONVERSATION', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
					survey_data: {
						name: window.user.name,
						phone: window.user.phone,
						email: window.user.email,
						address: window.user.address
					},
					properties: window.user.properties
				}).then((response) => {
					if (response.data.status == 1) {
						var data = response.data.data;
						setTimeout(function () {
							if ($self.lsTest() === true) {
								localStorage.clear();
							}
							top.postMessage({ reload_iframe: true }, document.referrer);
							$self.$store.commit('set_token', '');
							// socket.emit('load1',null);
							$self.refresh_token();

							$self.minimize();
						}, 150);
					}
				}).catch(error => {
					console.log(error);
				});


			},
			lsTest() {
				var test = 'test';
				try {
					localStorage.setItem(test, test);
					localStorage.removeItem(test);
					return true;
				} catch (e) {
					return false;
				}
			},
			uid() {
				return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, "");
			},
			isMobile() {
				/* Storing user's device details in a variable*/
				let details = navigator.userAgent;

				/* Creating a regular expression 
				containing some mobile devices keywords 
				to search it in details string*/
				let regexp = /android|iphone|kindle|ipad/i;

				/* Using test() method to search regexp in details
				it returns boolean value*/
				let isMobileDevice = regexp.test(details);

				if (isMobileDevice) {
					return true;
				} else {
					return false;
				}
			},
			download_msg_txt: function () {
				var $self = this;
				var text = '';
				this.messages.forEach(function (message, index) {
					if (message.user_id != $self.st_token) {
						text += "USER: ";
					} else {
						text += "AGENT: ";
					}
					if (message.text != '') {
						text += message.text + "\n";
					}

				});
				var filename = 'chat_transcript';

				var element = document.createElement('a');
				element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
				element.setAttribute('download', filename);
				element.style.display = 'none';
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);

			},
			refresh_token() {
				var $self = this;
				axios.get('/app/v1/public/load/').then((response) => {
					if (response.data.status == 1) {
						var st_token = response.data.st_token;
						livechat.addSetttinglocalStorage(livechat.getId() + '_omnichat', 'st_token', st_token);
						$self.st_token = st_token;
					}
				}).catch(error => {
					console.log(error);
				});
			},
			playSound(sound) {
				if (sound) {
					var audio = new Audio(sound);
					audio.volume = 0.4;
					audio.play();
				}
			},
			toggle_widget_setting: function () {
				$('.widget-setting-dropdown').toggleClass('visible');
			},
			scrollToEnd: function () {
				var $self = this;
				setTimeout(function () {
					$self.insertDateLine();
				}, 150);
				setTimeout(function () {
					var $chat_content = $(document).find('.chat-content');
					var chatbox = $(document).find('.chatbox');
					chatbox.scrollTop($chat_content.height() + 99999);
				}, 250);
			},
			insertDateLine: function () {
				var $self = this;
				var date_array = [];
				$(document).find('.chatbox .chat-date-separator').remove();
				$(document).find('.chatbox .chat-message-main').each(function (index, value) {
					var timestamp = $(this).find('.chat-message-date').attr('data-time');
					var d = new Date(timestamp * 1000);
					var curr_date = d.getDate();
					var curr_month = d.getMonth() + 1;
					var curr_year = d.getFullYear();
					var date = curr_date + '/' + curr_month + '/' + curr_year;
					if ($.inArray(date, date_array) >= 0) {

					} else {
						date_array.push(date);
						date = $self.MDFormat(curr_year + '-' + curr_month + '-' + curr_date);
						$('<div class="chat-date-separator"><span>' + date + '</span></div>').insertBefore($(this));
					}

				});
			},
			MDFormat: function (MMDD) {
				var $self = this;
				MMDD = new Date(MMDD.replace(/-/g, "/"));
				var vn_months = ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"];
				var en_months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
				var mths = '';
				if ($self.$i18n.locale == 'vi') mths = vn_months;
				else mths = en_months;
				var strDate = "";

				var tdaytime = new Date();
				tdaytime.setHours(0, 0, 0, 0);

				var yterday = new Date();
				yterday.setHours(0, 0, 0, 0);
				yterday.setDate(yterday.getDate() - 1);

				var tmrw = new Date();
				tmrw.setHours(0, 0, 0, 0);
				tmrw.setDate(tmrw.getDate() + 1);

				if (tdaytime.getTime() == MMDD.getTime()) {
					strDate = /*'Hôm nay';*/$self.$t('today');
				} else if (yterday.getTime() == MMDD.getTime()) {
					strDate = $self.$t('yesterday');//"Hôm qua";
				} else if (tmrw.getTime() == MMDD.getTime()) {
					strDate = $self.$t('tomorrow');
				} else {
					strDate = MMDD.getDate() + " " + mths[MMDD.getMonth()] + " " + MMDD.getFullYear();
				}

				return strDate;
			},
			showNotification: function (title, text, icon = this.page.button) {
				var hasFocus = this.hasFocus;
				if (window.Notification && !hasFocus) {
					if (Notification.permission === "granted") {
						text = text.replace('<br>', '');
						text = text.substring(0, 20);
						var n = new Notification(title, { body: text, icon: icon });
						setTimeout(n.close.bind(n), 5000);
						// };
					} else {
						console.log('Your browser doesn\'t support notifications.');
					}
				}
			},
			setLang: function (event) {
				var $self = this;
				var val = event.target.value;
				this.setting_language = val;
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			setLangNotificationEvent: function (val) {
				window.livechat.setSettingLanguage(val);
				this.$store.commit('set_lang', val);
				$self.$i18n.locale = val;

				//send event
				axios.post('/app/v1/public/CHANGE_LANGUAGE', {
					page_id: livechat.getId(),
					msg_id: $self.uid(),
					language: val,
					sender_id: $self.st_token,
					name: window.user.name,
					windowInfo: livechat.windowInfo,
				}).then((response) => {
				}).catch(error => {
					console.log(error);
				});
			},
			detectURL: function (message) {
				if (!message) return;

				var newMessage = this.restoreHtmlTag(message);

				if (newMessage.startsWith("<a") && newMessage.endsWith("</a>")) return newMessage;

				var pattern1 = /^([a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+.*)$/;

				if (pattern1.test(message) && message.substr(0, 3) != 'www') {
					var finalText = '<a href="' + message + '" target="_blank">' + message + '</a>';
				} else {
					var exp = /(\b(https?|ftps?|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
					if(exp.test(message)){
						var finalText = message.replace(exp, "<a href='$1'>$1</a>");
					}
					else{
						var urlPattern = /\b(?:https?|ftps?):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
						var pseudoUrlPattern = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
						var emailAddressPattern = /(([a-zA-Z0-9_\-\.]+)@[a-zA-Z_]+?(?:\.[a-zA-Z]{2,6}))+/gim;
						var phoneNumberPattern = /^[+ -](\+?1\s*[-.\s]?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4} /gim;
						var finalText = message
							.replace(urlPattern, '<a target="_blank" href="$&">$&</a>')
							.replace(pseudoUrlPattern, '$1<a target="_blank" href="http://$2">$2</a>')
							.replace(emailAddressPattern, '<a target="_blank" href="mailto:$1">$1</a>')
							.replace(phoneNumberPattern, '<a href="javascript:void(0)" class="click-phone" data-phone="$&">$&</a>');
					}
				}
				return this.restoreHtmlTag(finalText);
			},
			escapeHtml: function (text) {
				return text
					.replace(/&/g, "&amp;")
					.replace(/</g, "&lt;")
					.replace(/>/g, "&gt;")
					.replace(/"/g, "&quot;")
					.replace(/'/g, "&#039;");
			},
			restoreHtmlTag: function (text) {
				return text
					.replace(/&amp;/g, "&")
					.replace(/&lt;/g, "<")
					.replace(/&gt;/g, ">")
					.replace(/&quot;/g, '"')
					.replace(/&#039;/g, "'");
			},
			changePrev: function (index_message) {
				var el = $('#slides__' + index_message);
				var countElement = el.attr('data-elements');
				var slideElement = el.parent();

				if (!this.slideIndexes[index_message]) var currentSlide = 0;
				else var currentSlide = this.slideIndexes[index_message];

				if (currentSlide == 0) {
					currentSlide = countElement - 1;
					var prevSlide = currentSlide - 1;
					var nextSlide = 0;
				}
				else {
					currentSlide = currentSlide - 1;
					if (currentSlide != 0) var prevSlide = currentSlide - 1;
					else var prevSlide = countElement - 1;
					var nextSlide = currentSlide + 1;
				}

				var offsetLeft = $('#slide__' + index_message + '_' + currentSlide).width();
				el.scrollLeft(currentSlide * offsetLeft);

				this.slideIndexes[index_message] = currentSlide;
				var newHrefPrev = '#slide__' + index_message + '_' + prevSlide;
				var newHrefNext = '#slide__' + index_message + '_' + nextSlide;

				setTimeout(function () {
					$('#slide__prev_' + index_message).attr('href', newHrefPrev);
					$('#slide__next_' + index_message).attr('href', newHrefNext);
				}, 500)
			},
			changeNext: function (index_message) {
				var el = $('#slides__' + index_message);
				var countElement = el.attr('data-elements');
				if (!this.slideIndexes[index_message]) var currentSlide = 0;
				else var currentSlide = this.slideIndexes[index_message];
				if (currentSlide == countElement - 1) {
					currentSlide = 0;
					var prevSlide = countElement - 1;
					var nextSlide = currentSlide + 1;
				}
				else {
					currentSlide = currentSlide + 1;
					if (currentSlide == countElement - 1) var nextSlide = 0;
					else var nextSlide = currentSlide + 1;
					var prevSlide = currentSlide - 1;
				}

				var offsetLeft = $('#slide__' + index_message + '_' + currentSlide).width();
				el.scrollLeft(currentSlide * offsetLeft);

				this.slideIndexes[index_message] = currentSlide;
				var newHrefPrev = '#slide__' + index_message + '_' + prevSlide;
				var newHrefNext = '#slide__' + index_message + '_' + nextSlide;
				setTimeout(function () {
					$('#slide__prev_' + index_message).attr('href', newHrefPrev);
					$('#slide__next_' + index_message).attr('href', newHrefNext);
				}, 500)
			},

			openFormRating: function (message) {
				this.$store.commit('show_rating', true);
				this.customerFeedbackConfig = message.attachments.payload.feedback_screens[0].questions[0];
				this.customerFeedbackConfig.message_id = message.id
			},
			closeFormRating: function (dataEmit) {
				if (dataEmit.message_id != undefined) {
					var indexMes = this.messages.findIndex(mes => mes.id == dataEmit.message_id);
					if (indexMes != -1) {
						var mes = this.messages[indexMes];
						mes.is_rated = 1;
						mes.rating_star = dataEmit.rating_star;
						mes.rating_recommend = dataEmit.rating_recommend;
						this.messages.splice(indexMes, 1, mes);
					}
				}
				this.$store.commit('show_rating', false);
			},
			isHiddenName: function (keyMessage) {
				if (keyMessage == 0) return false;
				return this.messages[keyMessage].user_id == this.messages[keyMessage - 1].user_id &&
					this.messages[keyMessage].name == this.messages[keyMessage - 1].name
			},
			isHiddenTime: function (keyMessage) {
				if (this.messages[keyMessage + 1] == undefined) return false;
				return this.messages[keyMessage].user_id == this.messages[keyMessage + 1].user_id &&
					this.messages[keyMessage].name == this.messages[keyMessage + 1].name
			},
			closeModal: function () {
				$('#modalStatus').css('opacity', 0);
				$('#modalStatus').css('zIndex', -1);
			},
			closePhoneModal: function () {
				$('#modal-phonenumber').css('opacity', 0);
				$('#modal-phonenumber').css('zIndex', -1);
			},
			async copyPhoneNumber() {
				var _vmChat = this;
				try {
					const clipboardData =
						event.clipboardData ||
						window.clipboardData ||
						event.originalEvent?.clipboardData ||
						navigator.clipboard;

					clipboardData.writeText(_vmChat.phoneNumber);
					$('#modal-phonenumber').css('opacity', 0);
					$('#modal-phonenumber').css('zIndex', -1);
				} catch($e) {
					console.log($e);
				}
			}
		},
		mounted() {
			this.agent = {
				name: this.page.page_info.name,
				avatar: this.page.logo,
			};

			if (!this.isMobile()) {
				if (this.page.parent_user == 'C1184') {
					window.livechat.setSettingNoti(true);
					this.setting_noti = true;
				} else if (Notification.permission === "granted") {
					window.livechat.setSettingNoti(true);
					this.setting_noti = true;
				} else {
					window.livechat.setSettingNoti(false);
				}
			} else {
				window.livechat.setSettingNoti(true);
			}

			// console.log(ENV);
			var $self = this;
			if ($self.st_token) {
				this.get_messages();
			}

			/*socket.on('get_agent', (data) => {
			  $self.agent = data;
			});*/

			/* setTimeout(function(){
			   $self.scrollToEnd();
			   alert('scroll1');
			 }, 2500);*/
			$('.chatbox').on('click', '.click-phone', function () {
				var phoneNumber = $(this).attr('data-phone');
				if (phoneNumber) {
					$self.phoneNumber = phoneNumber;
					$('#modal-phonenumber').css('opacity', 1);
					$('#modal-phonenumber').css('zIndex', 999999999);
				}
			})
		},
		watch: {
			show_launcher: function (val) {
				var $self = this;
				if (val == 1) {
					setTimeout(function () {
						$self.scrollToEnd();
						$self.insertDateLine();
					}, 150);
				}
			},
			setting_sound: function (val) {
				window.livechat.setSettingSound(val);
			},
			hasFocus: function (val) {
			},
			/*lang: function(val){
			  // this.setting_language = val;
			  window.livechat.setSettingLanguage(val);
			  this.$store.commit('set_lang', val);
			},*/
			/*setting_noti: function(val){
			  window.livechat.setSettingNoti(val);
			},*/

			show_rating: function (val) {
				var $self = this;
				setTimeout(function () {
					$self.insertDateLine();
				}, 150);
				$self.scrollToEnd();
			},

			/*setting_language: function(val){
			  this.$emit('swithLang', this.setting_language);
			  // var Languages = window.livechat.getLanguages();
			},*/
			agent_id: function (val) {
				var $self = this;
				if (val != '') {
					// socket.emit('get_agent', {st_token:$self.st_token, agent_id: val});
				}
			},

		},

	}

</script>
<style scoped lang="css">
	#greenBar{position: initial;}
	#greenBar i{
		position: absolute;
		z-index: 99;
		right: 1px;
		top: 1px;
		font-size: 1.5em;
		color: #0ce6e7;
	}
	.file_pdf_progress .video-icon .title  >div{position: relative;}
	.video-icon img,.video-icon .img{position: relative;width: 42px ;float: left;}
	.video-icon .img{display: table;text-align: center;}
	.video-icon .img span{display: table-cell;vertical-align: middle;text-transform: uppercase;text-align: center;color:#fff;font-weight: bold;}
	.video-icon .title{position: relative;width:calc(100% - 42px)  ;float: left;text-align: left;padding:0px 0 0 5px}
	.video-icon .title >div >span{    font-size: .7rem;  font-weight: 500; font-style: italic;}
	.chat-message.chat-message-main  .chat-message-content-w{overflow: hidden;position: relative;}
	.chat-message.chat-message-main .video_content,
	.chat-message.chat-message-main .file_pdf{float: left;background-color:#e5efff}
	.chat-message.chat-message-main .video_content video{border:1px solid #f6f6f6;border-radius: 10px;}
	.chat-message.chat-message-main.self .video_content,
	.chat-message.chat-message-main.self .file_pdf{float: right;border-radius: 10px;}
	.chat-message.chat-message-main.self .file_pdf h5{max-height:32px;overflow: hidden;}
	
	
	.suggestions.PredictiveSuggestions__list__container {
		/*padding: 6px ​10px 0px 15px;*/
		/*padding: 10px;*/
		padding-top: 6px;
		padding-right: 10px;
		padding-bottom: 00px;
		padding-left: 15px;
		border-top: 1px solid rgb(232, 232, 235);
		/*transition: border-color 200ms ease-in 0s;*/
		position: relative;
	}

	.PredictiveSuggestions__suggestions-heading {
		text-align: left;
		display: inline-block;
		font-size: 13px;
		font-weight: 600;
		background: transparent;
		border: none;
		cursor: pointer;
		color: #484848;
	}

	/*.PredictiveSuggestions__icon {
    display: inline-block;
    background: transparent;
    border: none;
    padding: 0px;
    margin: 0px;
}



.PredictiveSuggestions__icon svg {
    pointer-events: all;
    cursor: pointer;
    opacity: 1;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    outline: none;
}
*/
	/*.PredictiveSuggestions__list__chevron--show {
    transform: rotate(0deg);
    transition: transform 0.3s ease-out;
}*/
	.PredictiveSuggestions__list__items--animate-in {
		opacity: 1;
		transition-delay: 0.2s;
		transition-delay: 0.5s;
		transition: opacity 0.75s ease-out;
	}

	.PredictiveSuggestions--animating-list-up {
		opacity: 1;
		transition-duration: 0.2s;
		transition-delay: 0.1s;
		transition-timing-function: ease-out;
	}

	.PredictiveSuggestions__list--desktop {
		margin-bottom: 12px;
	}

	.PredictiveSuggestions__list {
		margin: 0;
		padding: 0;
		list-style-type: none;
	}

	.PredictiveSuggestions__item {
		overflow: hidden;
		display: block;
		position: relative;
		text-align: left;
		border: none;
		font-size: 14px;
		padding: 0px;
		background: transparent;
		margin-right: 16px;
		height: 0px;
		opacity: 0px;
		cursor: pointer;
		height: 30px;
		opacity: 1;
		animation: flickerAnimation 0.5s infinite;
		color: rgb(240, 14, 14);
		animation-play-state: paused;
	}

	.PredictiveSuggestions__item:not(:hover) {
		text-decoration: none;
	}

	.PredictiveSuggestions__item:hover {
		text-decoration: underline;
	}

	.PredictiveSuggestions--collapsed {
		max-height: 36px;
	}

	.PredictiveSuggestions--collapsed ul.PredictiveSuggestions__list {
		/*display: none;*/
	}

	.PredictiveSuggestions--collapsed .PredictiveSuggestions__icon {
		transform: rotate(-180deg);
		transition: transform 0.2s ease-out;
	}

	.chat-message-main span.message {
		white-space: pre-line;
	}

	.mini-menu {
		z-index: 999;
		position: absolute;
		bottom: 43px;
		background: #fff;
		right: 72px;
	}

	.mini-menu ul li {
		position: relative;
		display: block;
		padding: 0.75rem 0.5rem;
		margin-bottom: -1px;
		background-color: #fff;
		border: 1px solid rgba(0, 0, 0, .125);
	}

	.mini-menu ul li:first-child {
		border-top-left-radius: 0.25rem;
		border-top-right-radius: 0.25rem;
	}

	.chat-controls {
		position: relative;
	}

	.mini-menu ul li:last-child {
		margin-bottom: 0;
		border-bottom-right-radius: 0.25rem;
		border-bottom-left-radius: 0.25rem;
	}

	.mini-menu ul li a {
		color: #2165ff;
		font-weight: 500;
	}

	/*hieu update*/
	.slide__next,
	.slide__prev,
	.slider:after,
	.slider:before {
		position: absolute;
		top: 5px;
		left: 5px;
		width: 12px;
		height: 12px;
		border: solid #000;
		border-width: 0 5px 5px 0;
		padding: 3px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}

	.slider-container .wrap-arrow {
		position: absolute;
		top: 43%;
		z-index: 99999;
		width: 25px;
		height: 25px;
		border: 1px solid #cdcdcd;
		border-radius: 50%;
		overflow: hidden;
		background-color: #fff;
		cursor: pointer;
	}

	.slider-container .wrap-arrow.wrap-arrow-prev {
		left: 0;
	}

	.slider-container .wrap-arrow.wrap-arrow-next {
		right: 0;
	}

	.slider-container .wrap-arrow .inner-arrow {
		position: relative;
		display: block;
	}

	/*end hieu update */

	.slider-container {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		overflow: hidden;
	}

	.slider {
		width: 100%;
		/* height: 302px; */
		text-align: center;
		border-radius: 20px;
		overflow: hidden;
		position: relative;
	}

	.slides {
		display: flex;
		overflow-x: scroll;
		position: relative;
		scroll-behavior: smooth;
		scroll-snap-type: x mandatory;
		overflow: hidden;
	}

	/* .slide:nth-of-type(even) {
  background-color: rgb(250, 246, 212);
} */

	.slide {
		/*display: flex;*/
		justify-content: center;
		align-items: center;
		flex-shrink: 0;
		width: 100%;
		/* height: 400px; */
		scroll-snap-align: center;
		margin-right: 0px;
		box-sizing: border-box;
		background: white;
		transform-origin: center center;
		transform: scale(1);
	}

	.slide.slide--feedback {
		height: 100%;
	}

	.slide__text {
		font-size: 40px;
		/*font-weight: bold;*/
		font-family: sans-serif;
		height: 100%
	}

	.slide a {
		background: none;
		border: none;
	}

	a.slide__prev,
	.slider::before {
		transform: rotate(135deg);
		-webkit-transform: rotate(135deg);
		left: 30%;
	}

	a.slide__next,
	.slider::after {
		transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		right: 35%;
	}

	.slider img {
		display: block;
		width: 100%;
		height: 200px;
		/*border-radius: 20px 20px 0 0;*/
	}

	.slider .detail {
		background: #f3f3f5;
		/*border-radius: 0px 0px 20px 20px;*/
		padding: 10px 10px;
		height: calc(100% - 200px);
	}

	.slider .title {
		font-size: 1.0375rem;
		font-weight: bold;
		text-align: center;
		color: #050505;
		text-align-last: center;

	}

	.slider .des {
		text-align: left;
		color: #65676B;
		font-size: .8125rem;
	}

	.slider .button {
		background: #e4e6eb;
		border: 0 none;
		border-radius: 10px;
		color: #050505;
		cursor: pointer;
		font-weight: bold;
		padding: 10px;
		text-transform: uppercase;
		width: 100%;
		font-size: .9375rem;
		display: inline-block;
	}

	.slides>div {
		margin-right: 1px;
		/* scroll-snap-align: start;
  flex-shrink: 0;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s; */
	}

	/* .slide:not(.current_slide) {
  display: none;
}
.slide.current_slide{
  transition: 1s;
  left: 0;
} */

	.table-content-list {
		list-style: none;
	}

	.table-content-list li {
		padding: 5px
	}

	.table-content-list li {
		padding: 5px
	}

	.table-content-list li .item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		margin-bottom: 10px;
	}

	.table-content-list li .item span:first-child {
		width: 116px;
		margin-right: 6px;
	}

	.table-content-list li .item span {
		display: block;
		font-size: 1rem;
		line-height: 18px;
		word-break: break-word;
	}

	.table-content-list li .item span {
		color: #394E60;
	}

	.table-content-list li .item span:nth-child(2) {
		display: inline-block;
	}

	.slide__text--ticket {
		margin: 10px;
	}

	.slider--ticket {
		text-align: unset;
	}

	.detail--ticket {
		background-color: unset !important;
	}

	.text-center {
		text-align: center;
	}

	h6 {
		font-size: 1rem;
		font-weight: 400;
	}

	.slide__text--ticket__title {
		font-weight: 700;
		font-size: 1rem;
		line-height: 24px;
		padding: 0;
		margin-bottom: 6px;
	}

	.slide__text--ticket__subtitle {
		display: block;
		font-size: 0.875rem;
		margin-bottom: 12px;
		line-height: 20px;
	}

	.slider--ticket .slide {
		border-radius: 8px;
		background-color: #f9f7f7;
		height: 450px;
	}

	.button-disabled {
		color: #a7b3bf
	}

	.rating {
		display: inline-block;
		flex-direction: column;
		align-items: center;
		color: #b7b7b7;
		border-radius: 8px;
	}

	.rating .list {
		padding: 0;
		margin: 0 20px 0 0;
		width: unset;
	}

	.rating .list .star {
		display: inline-block;
		font-size: 20px;
		transition: all .2s ease-in-out;
		cursor: pointer;
	}

	.rating .list .star.active {
		color: #ffe100;
	}

	.rating .list .star:first-child {
		margin-left: 0;
	}

	.mt-1 {
		margin-top: 1rem;
	}

	.modal-wrapper {
		position: fixed;
		top: 20px;
		right: 39px;
		bottom: 18px;
		left: 0;

		background: rgba(0, 0, 0, 0.8);
		z-index: -1;
		opacity: 0;

		-webkit-transition: opacity 0.2s ease-in;
		-moz-transition: opacity 0.2s ease-in;
		transition: opacity 0.2s ease-in;

		pointer-events: auto;
		border-radius: 10px;
	}

	.modal-wrapper>div {
		width: 90%;
		height: 15%;
		position: absolute;

		top: 0;
		bottom: 0;
		left: 0;
		right: 0;

		margin: auto;

		vertical-align: middle;
		padding: 20px;
		border-radius: 6px;
		border: rgb(22, 136, 197) solid 1px;
		background: #fff;
		z-index: 1;
		text-align: center;
	}

	.close {
		background: rgb(22, 136, 197);
		color: #ffffff;
		line-height: 25px;
		position: absolute;
		right: -12px;
		text-align: center;
		top: -10px;
		width: 24px;
		text-decoration: none;
		font-weight: bold;
		-webkit-border-radius: 12px;
		-moz-border-radius: 12px;
		border-radius: 12px;
	}

	.close:hover {
		background: rgb(22, 136, 197);
	}

	#modal-phonenumber .modal {
		text-align: initial;
		padding: 0;
		height: 20%;
	}

	#modal-phonenumber .modal-header {
		text-align: initial;
		padding: 15px;
		border-bottom: solid 1px #1688c5;
	}

	#modal-phonenumber .modal-content {
		text-align: initial;
		padding: 15px;
	}
</style>